import * as marietta from '../..';
import { ITEM_MODE_NO, SITE_INPUT_MODE } from '../Constants';
import { SVGSprite } from '../flash/display';

/**
 * サイトのitemcontrollerクラス
 */
export default class ItemControllerSite {
  target: marietta.webcad.item.Site;

  cornerPickerList: marietta.webcad.control.parts.SiteCornerDragger[] = [];

  stretchLines: marietta.webcad.control.parts.StrechLine[] = [];

  stretchLineTexts: marietta.webcad.control.parts.StrechLineText[] = [];

  startPoint: marietta.core.Point;

  currentWall: marietta.webcad.control.parts.RoomCornerDragger;

  x: number;

  y: number;

  prevPoint: marietta.core.Point;

  public spt: SVGSprite;

  public emptySpt: SVGSprite;

  /**
   * コンストラクタ
   */
  constructor(_target: marietta.webcad.item.Site) {
    // ターゲット
    this.target = _target;
    // 作成する階
    const tarLayer: marietta.webcad.layer.FloorShitaeLayer = marietta.webcad.WebCADGlobal.layerGroup.getFloorLayer(this.target.itemInfo.floor, true) as marietta.webcad.layer.FloorShitaeLayer;
    // 形状の生成
    const viewObj: Element = document.createElementNS('http://www.w3.org/2000/svg', 'g');
    viewObj.id = 'controller';
    this.spt = new SVGSprite(viewObj);

    // コントローラー追加
    const points: number = this.target.itemInfo.dotList.length;
    let corner: marietta.webcad.control.parts.SiteCornerDragger;
    let line: marietta.webcad.control.parts.StrechLine;
    let text: marietta.webcad.control.parts.StrechLineText;
    for (let i: number = 1; i <= points; i += 1) {
      corner = new marietta.webcad.control.parts.SiteCornerDragger(this.spt, i);
      corner.moveFunc = this.onMoveCornerDragger;
      corner.moveEndFunc = this.onMoveEndCornerDragger;
      if (marietta.webcad.WebCADGlobal.webcad2Dmanager.currentSiteInputMode === SITE_INPUT_MODE.SITE_DETAILED_INPUT_MODE) {
        corner.hide();
      }
      this.cornerPickerList.push(corner);

      // ラインの作成
      line = new marietta.webcad.control.parts.StrechLine(this.spt, i);
      this.stretchLines.push(line);
      // テキスト
      text = new marietta.webcad.control.parts.StrechLineText(this.spt, i);
      text.hide();
      this.stretchLineTexts.push(text);
    }

    tarLayer.spt.addChild(this.spt);
    // コントローラーの位置調整
    this.setArrowPositions();
    // ターゲットに合わせてサイズ変更
    this.resizeToTarget();
  }

  /**
   * コントロールピッカーが移動された
   */
  onMoveCornerDragger = (e: MouseEvent, target: marietta.webcad.control.parts.RoomCornerDragger) => {
    // ロックされている場合は、行わない
    if (!this.target.isCapableOfResize()) return;
    // 開始時のアイテム場所保持
    if (this.startPoint === undefined || this.startPoint === null) {
      this.currentWall = target;
      if (!this.emptySpt) {
        /*
          本来はtarget.sptのmouseX/mouseYで取得できるが、
          拡縮するとアイテムの位置が変わるため、正しいドラッグ位置が取れなくなる。
          そのためタグを持たないemptySptを別途作って、mouseX/mouseYの値を
          取得している。
        */
        this.emptySpt = new SVGSprite(null, true);
        this.emptySpt.setEmptyParam(this.target.spt);
        this.target.spt.parent.addChild(this.emptySpt);
      }

      this.startPoint = new marietta.core.Point(this.emptySpt.mouseX * this.target.spt.scaleX, this.emptySpt.mouseY * this.target.spt.scaleY);
      // 敷地を隠す
      this.target.spt.visible = false;
      this.target.spt.update();
    }

    const newPoint: marietta.core.Point = new marietta.core.Point(this.emptySpt.mouseX * this.target.spt.scaleX, this.emptySpt.mouseY * this.target.spt.scaleY);
    const snapPosition: marietta.core.Point = ItemControllerSite.getSnapPosition(newPoint);
    target.move(snapPosition.x, snapPosition.y);

    let line: marietta.webcad.control.parts.StrechLine;
    let text: marietta.webcad.control.parts.StrechLineText;
    let i: number;
    let tarSymbol: marietta.webcad.control.parts.SiteCornerDragger;
    // ラインとドットの伸縮
    for (i = 0; i < this.stretchLines.length; i += 1) {
      line = this.stretchLines[i];
      text = this.stretchLineTexts[i];
      text.show();
      tarSymbol = this.cornerPickerList[i] as marietta.webcad.control.parts.SiteCornerDragger;
      line.firstDot = new marietta.core.Point(tarSymbol.x, tarSymbol.y);
      text.firstDot = new marietta.core.Point(tarSymbol.x, tarSymbol.y);

      if (i === this.stretchLines.length - 1) {
        tarSymbol = this.cornerPickerList[0] as marietta.webcad.control.parts.SiteCornerDragger;
        line.secondDot = new marietta.core.Point(tarSymbol.x, tarSymbol.y);
        text.secondDot = new marietta.core.Point(tarSymbol.x, tarSymbol.y);
      } else {
        tarSymbol = this.cornerPickerList[i + 1] as marietta.webcad.control.parts.SiteCornerDragger;
        line.secondDot = new marietta.core.Point(tarSymbol.x, tarSymbol.y);
        text.secondDot = new marietta.core.Point(tarSymbol.x, tarSymbol.y);
      }
    }
  }

  /**
   * コントロールピッカーのドラッグ終了
   */
  onMoveEndCornerDragger = () => {
    // 敷地同期させる
    this.setSiteToMe();
    // 敷地を隠す
    this.target.spt.visible = true;
    this.target.spt.update();

    let text: marietta.webcad.control.parts.StrechLineText;
    let i: number;
    // ラインとドットの伸縮
    for (i = 0; i < this.stretchLines.length; i += 1) {
      text = this.stretchLineTexts[i];
      text.hide();
    }

    // アイテムコントローラーの再設定（見た目を整える）
    marietta.webcad.WebCADGlobal.itemManager.currentItem = this.target;
    this.startPoint = null;
    this.currentWall = null;
    if (this.emptySpt && this.emptySpt.parent) {
      this.emptySpt.parent.removeChild(this.emptySpt);
      this.emptySpt = null;
    }
  }

  // サイト回転
  rotateItem(angle: number) {
    const newAngle: number = angle * (Math.PI / 180);
    const points = [];
    for (let i = 0; i < this.target.itemInfo.dotList.length; i += 1) {
      const rotatedX = Math.cos(newAngle) * (this.target.itemInfo.dotList[i].x + this.target.itemInfo.x - this.target.itemInfo.x) - Math.sin(newAngle) * (this.target.itemInfo.dotList[i].y + this.target.itemInfo.y - this.target.itemInfo.y) + this.target.itemInfo.x;
      const rotatedY = Math.sin(newAngle) * (this.target.itemInfo.dotList[i].x + this.target.itemInfo.x - this.target.itemInfo.x) + Math.cos(newAngle) * (this.target.itemInfo.dotList[i].y + this.target.itemInfo.y - this.target.itemInfo.y) + this.target.itemInfo.y;
      points.push(new marietta.core.Point(rotatedX, rotatedY));
    }

    for (let i = 0; i < points.length; i += 1) {
      this.target.itemInfo.dotList[i].point.x = points[i].x - this.target.itemInfo.x;
      this.target.itemInfo.dotList[i].point.y = points[i].y - this.target.itemInfo.y;
      this.target.itemInfo.dotList[i].x = points[i].x - this.target.itemInfo.x;
      this.target.itemInfo.dotList[i].y = points[i].y - this.target.itemInfo.y;
    }

    this.target.reCreateImage();
    this.setArrowPositions();
    this.resizeToTarget();
    ItemControllerSite.updateSiteText();
  }

  /**
   * ターゲットに合わせて各種パーツリサイズ
   */
  resizeToTarget() {
    // 頂点を変換する
    (this.target as marietta.webcad.item.Site).convertDotsToCenter();
    // 位置合わせ
    this.syncMeToTarget();
    this.updateTransforms();
  }

  /**
   * ターゲットにシンクロする
   * ※アイテムのドラッグ時に呼び出される
   */
  syncMeToTarget() {
    this.x = this.target.itemInfo.x;
    this.y = this.target.itemInfo.y;
    this.updateTransforms();
  }

  /**
   * 矢印をグリッドにスナップさせる
   * */
  private static getSnapPosition(point: marietta.core.Point) {
    const snapUnit = 1;
    const gridPlace: marietta.core.Point = new marietta.core.Point(0, 0);
    gridPlace.x = Math.round(point.x / snapUnit) * snapUnit;
    gridPlace.y = Math.round(point.y / snapUnit) * snapUnit;
    return gridPlace;
  }

  /**
   * 敷地の大きさを変える
   * */
  setSiteToMe(force: Boolean = false) {
    if (force) this.prevPoint = null;
    if (!this.emptySpt) return;
    // 前回と同じ位置なら、行わない
    if (this.prevPoint != null && (this.prevPoint.x === this.emptySpt.mouseX && this.prevPoint.y === this.emptySpt.mouseY)) return;
    this.prevPoint = new marietta.core.Point(this.emptySpt.mouseX, this.emptySpt.mouseY);

    // 敷地アイテムに更新
    this.target.itemInfo.dotList = this.currentCoordinates;
    this.target.reCreateImage();
    // 関連するシンボルの位置移動
    this.setArrowPositions();
  }

  /**
   * 現在の座標を取得
   * */
  get currentCoordinates(): marietta.webcad.collection.PointCollection[] {
    // 基本的な情報は引き継ぐ
    const points: number = this.cornerPickerList.length;
    const myCoordinates: marietta.webcad.collection.PointCollection[] = [];
    for (let i: number = 0; i < points; i += 1) {
      myCoordinates.push(this.target.itemInfo.dotList[i]);
    }
    let tarSymbol: marietta.webcad.control.parts.SiteCornerDragger;
    // グローバル座標
    for (let i = 0; i < points; i += 1) {
      tarSymbol = this.cornerPickerList[i] as marietta.webcad.control.parts.SiteCornerDragger;
      myCoordinates[i].x = tarSymbol.x;
      myCoordinates[i].y = tarSymbol.y;
    }
    return myCoordinates;
  }

  /**
   * 矢印位置を合わせる
   * */
  setArrowPositions() {
    // 頂点作成
    let cornerPicker: marietta.webcad.control.parts.SiteCornerDragger;
    let line: marietta.webcad.control.parts.StrechLine;
    let text: marietta.webcad.control.parts.StrechLineText;
    let i: number;

    for (i = 0; i < this.cornerPickerList.length; i += 1) {
      cornerPicker = this.cornerPickerList[i];
      cornerPicker.move(this.target.itemInfo.dotList[i].x, this.target.itemInfo.dotList[i].y);
    }
    for (i = 0; i < this.stretchLines.length; i += 1) {
      line = this.stretchLines[i];
      text = this.stretchLineTexts[i];
      line.firstDot = new marietta.core.Point(this.target.itemInfo.dotList[i].x, this.target.itemInfo.dotList[i].y);
      text.firstDot = new marietta.core.Point(this.target.itemInfo.dotList[i].x, this.target.itemInfo.dotList[i].y);

      if (i === this.stretchLines.length - 1) {
        line.secondDot = new marietta.core.Point(this.target.itemInfo.dotList[0].x, this.target.itemInfo.dotList[0].y);
        text.secondDot = new marietta.core.Point(this.target.itemInfo.dotList[0].x, this.target.itemInfo.dotList[0].y);
      } else {
        line.secondDot = new marietta.core.Point(this.target.itemInfo.dotList[i + 1].x, this.target.itemInfo.dotList[i + 1].y);
        text.secondDot = new marietta.core.Point(this.target.itemInfo.dotList[i + 1].x, this.target.itemInfo.dotList[i + 1].y);
      }
    }
    // お掃除
    cornerPicker = null;
  }

  /**
   * Translateのアップデート
   */
  updateTransforms() {
    this.spt.x = this.x;
    this.spt.y = this.y;
    this.spt.update();
  }

  /**
   * ピッカーのサイズ更新
   */
  public updatePickers(): void {
    for (let i: number = 0; i < this.cornerPickerList.length; i += 1) {
      (this.cornerPickerList[i] as marietta.webcad.control.parts.SiteCornerDragger).updateTranslate();
    }
    ItemControllerSite.updateSiteText();
  }

  /**
   * サイトテキストを更新
   */
  public static updateSiteText(): void {
    const tarLayer: marietta.webcad.layer.SiteLayer = marietta.webcad.WebCADGlobal.layerGroup.getTypeLayerInFloorLayer(1, ITEM_MODE_NO.MODE_SITE_NO);
    const itemList: any[] = tarLayer.getAllChildren();
    // let tarItem: marietta.webcad.item.Site;
    const allItemList: any[] = [];
    for (let i = 0; i < itemList.length; i += 1) {
      allItemList.push(itemList[i] as marietta.webcad.item.Site);
    }
    let lineList = [];
    const linesList = [];
    for (let i = 0; i < allItemList.length; i += 1) {
      lineList = allItemList[i].lines;
      for (let k = 0; k < lineList.length; k += 1) {
        linesList.push(lineList[k]);
      }
    }
    for (let i: number = 0; i < linesList.length; i += 1) {
      (linesList[i].partnerText as marietta.webcad.item.parts.SiteText).updateTranslate();
    }
  }
}
